import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { Container } from "@react-email/components";
import { EMAIL_DESKTOP_MAX_WIDTH } from "../../Design/mediaQuery";

export interface RootProps extends ComponentPropsWithRef<"table"> {
  children: ReactNode;
}

export const RootBlock = forwardRef<HTMLTableElement, RootProps>(
  ({ children, style, ...rest }, ref) => (
    <Container
      ref={ref}
      style={{
        position: "relative",
        height: "100%",
        maxWidth: `${EMAIL_DESKTOP_MAX_WIDTH}px`,
        fontFamily: "Helvetica Neue,Helvetica,Arial,sans-serif",
        wordWrap: "break-word",
        wordBreak: "break-word",
        ...style,
      }}
      {...rest}
    >
      {children}
    </Container>
  ),
);

RootBlock.displayName = "Root";
